import { load } from 'extendable-media-recorder-wav-encoder-broker';
import { worker } from './worker/worker';
var blob = new Blob([worker], { type: 'application/javascript; charset=utf-8' });
var url = URL.createObjectURL(blob);
var extendableMediaRecorderWavEncoder = load(url);
export var characterize = extendableMediaRecorderWavEncoder.characterize;
export var connect = extendableMediaRecorderWavEncoder.connect;
export var disconnect = extendableMediaRecorderWavEncoder.disconnect;
export var encode = extendableMediaRecorderWavEncoder.encode;
export var isSupported = extendableMediaRecorderWavEncoder.isSupported;
export var record = extendableMediaRecorderWavEncoder.record;
URL.revokeObjectURL(url);
//# sourceMappingURL=module.js.map
